// AUTO-GENERATED — do not edit.
// Source: business/ishvaram/data/contracts/browser_automation_policy.yaml
// Regenerate: uv run python execution/generate_browser_automation_policy.py

export const BROWSER_AUTOMATION_POLICY_VERSION = 2 as const;
// prettier-ignore
export const AUTOMATED_BROWSER_USER_AGENT_PATTERN = "(?:\\b(?:crawler|spider|slurp|headlesschrome|lighthouse|chrome-lighthouse|scanner|monitor|preview)\\b|(?:^|[\\s;(])[^()\\s;/]*bot(?:[/\\s;)]|$)|(?:^|\\s)(?:curl|wget)/|\\bIshvaram[A-Za-z0-9]*(?:Corpus|Guard|Audit|Sample|Probe|Evidence|Crawl|Verifier)\\b)";
export const CLOUDFLARE_VERIFIED_BOT_IS_AUTOMATED = true as const;
export const CLOUDFLARE_VERIFIED_BOT_CATEGORY_IS_AUTOMATED = true as const;
export const CLOUDFLARE_DEFINITE_BOT_SCORES: ReadonlySet<number> = new Set([1]);
